import { render, staticRenderFns } from "./SendMailableAside.vue?vue&type=template&id=700fa840&scoped=true&"
import script from "./SendMailableAside.vue?vue&type=script&lang=js&"
export * from "./SendMailableAside.vue?vue&type=script&lang=js&"
import style0 from "./SendMailableAside.vue?vue&type=style&index=0&id=700fa840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700fa840",
  null
  
)

export default component.exports